import { Color } from "../Model/Color";
import { ColorRepository } from "../Repository/ColorRepository";

export interface GetCategoryUseCase {
  invoke: () => Promise<Color[]>;
}

export class GetColors implements GetCategoryUseCase {
  private colorRepo: ColorRepository;
  constructor(_ColorRepo: ColorRepository) {
    this.colorRepo = _ColorRepo;
  }

  async invoke(){
     
    const getData = await this.colorRepo.getColors();
    return getData;
  }
}